import { useState } from 'react';
import styled from 'styled-components';
import { eventApi } from '../../../core/api/rtk-query/event.api';

const Backdrop = styled.div`position:fixed; inset:0; background:rgba(13,25,41,.36); display:flex; align-items:center; justify-content:center;`;
const Modal = styled.div`width:720px; max-width:calc(100% - 24px); background:#fff; border-radius:16px; border:1px solid #e5e8f0; box-shadow:0 16px 48px rgba(0,0,0,.08); padding:16px; display:grid; gap:12px;`;
const Row = styled.div`display:flex; gap:8px; align-items:center;`;
const Btn = styled.button`background:#fff; border:1px solid #dbe3f6; color:#0b1221; padding:8px 12px; border-radius:10px; cursor:pointer;`;
const Table = styled.table`width:100%; border-collapse:collapse;`;
const Th = styled.th`text-align:left; padding:8px; border-bottom:1px solid #eef;`;
const Td = styled.td`padding:8px; border-bottom:1px solid #f3f6ff;`;

export const ResultsModal = ({ eventId, onClose }: { eventId: string; onClose: () => void }) => {
  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 50;
  const { data } = eventApi.useGetUserAttemptsQuery({ eventId, reviewed: false, pageNumber, pageSize });

  return (
    <Backdrop onClick={onClose}>
      <Modal onClick={e=> e.stopPropagation()}>
        <Row style={{justifyContent:'space-between'}}>
          <div style={{fontWeight:700}}>Результаты</div>
          <Btn onClick={onClose}>Закрыть</Btn>
        </Row>
        <div>Участников: {data?.number ?? 0}</div>
        <div style={{overflow:'auto', maxHeight:420}}>
          <Table>
            <thead>
              <tr>
                <Th>Пользователь</Th>
                <Th>Баллы</Th>
                <Th>Статус</Th>
              </tr>
            </thead>
            <tbody>
              {data?.userAttempts?.map(u => (
                <tr key={u.userId}>
                  <Td>{u.name}</Td>
                  <Td>{u.problemScores.reduce((s,p)=> s + p.userScore, 0)}/{u.problemScores.reduce((s,p)=> s + p.maximumScore, 0)}</Td>
                  <Td>submitted</Td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Modal>
    </Backdrop>
  );
};


